var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.0417C13.675 11.0417 13.9583 10.7584 13.9583 10.4167C13.9583 10.0751 13.675 9.79175 13.3333 9.79175H11.0417V4.79175H13.3333C13.675 4.79175 13.9583 4.50841 13.9583 4.16675C13.9583 3.82508 13.675 3.54175 13.3333 3.54175H7.5C7.15833 3.54175 6.875 3.82508 6.875 4.16675C6.875 4.50841 7.15833 4.79175 7.5 4.79175H9.79167V15.0001C9.79167 16.2667 10.8167 17.2917 12.0833 17.2917H13.3333C13.675 17.2917 13.9583 17.0084 13.9583 16.6667C13.9583 16.3251 13.675 16.0417 13.3333 16.0417H12.0833C11.5083 16.0417 11.0417 15.5751 11.0417 15.0001V11.0417H13.3333Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 18.3333H14.333C13.783 18.3333 13.333 17.8833 13.333 17.3333V16C13.333 15.45 13.783 15 14.333 15H17.333C17.883 15 18.333 15.45 18.333 16V17.3333C18.333 17.8833 17.883 18.3333 17.333 18.3333Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 6.66675H3.33366C2.41699 6.66675 1.66699 5.91675 1.66699 5.00008V3.33341C1.66699 2.41675 2.41699 1.66675 3.33366 1.66675H5.83366C6.75033 1.66675 7.50033 2.41675 7.50033 3.33341V5.00008C7.50033 5.91675 6.75033 6.66675 5.83366 6.66675Z",
    fill: "#838B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 5.83333H14.333C13.783 5.83333 13.333 5.38332 13.333 4.83332V3.50001C13.333 2.95001 13.783 2.5 14.333 2.5H17.333C17.883 2.5 18.333 2.95001 18.333 3.50001V4.83332C18.333 5.38332 17.883 5.83333 17.333 5.83333Z",
    fill: "#838B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.333 12.0833H14.333C13.783 12.0833 13.333 11.6333 13.333 11.0833V9.75001C13.333 9.20001 13.783 8.75 14.333 8.75H17.333C17.883 8.75 18.333 9.20001 18.333 9.75001V11.0833C18.333 11.6333 17.883 12.0833 17.333 12.0833Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData2);
export default __webpack_public_path__ + "static/media/data-2.c3de4a78acd2c7765a06fe023b3825e5.svg";
export { ForwardRef as ReactComponent };